import type { EcommerceData } from "../get-ecommerce-data";

export function applyItemEventData(
  ecommerceData: EcommerceData,
  eventParams: {
    coupon?: string;
    quantity?: number;
  },
) {
  return ecommerceData.items.map((item) => ({
    ...item,
    coupon: eventParams.coupon,
    quantity: eventParams.quantity ?? item.quantity,
  }));
}

export function calculateItemValue(items: EcommerceData["items"]): number {
  return items.reduce(
    (total, item) => total + (item.price ?? 0) * (item.quantity ?? 1),
    0,
  );
}
